import React from 'react';
import FormSection from '../FormElements/FormSection';
import TextInput from '../FormElements/TextInput';
import PasswordInput from '../FormElements/PasswordInput';
import FormFooterLink from '../FormElements/FormFooterLink';
import FormSubmit from '../FormElements/FormSubmit';
import PermissionsHelper from '../../libraries/permissionsHelper';

export default class Signin extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			loading: false,
			principal: '',
			password: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		// console.log('SignIn', this.props)

		return (
			<div className="Signin FormElements">
				{this.state.error && (
					<div
						className="alert alert-danger"
						dangerouslySetInnerHTML={{
							__html: I18n.t(this.state.error, {
								login_path: this.props.sign_in_path
							})
						}}
					/>
				)}
				{!this.props.interactive_sign_in_enabled ? (
					<div
						className="alert alert-danger"
						dangerouslySetInnerHTML={{
							__html: I18n.t('GENERIC_ERROR')
						}}
					/>
				) : (
					<form onSubmit={this.onSubmit}>
						<h1>{I18n.t('admin.welcome_text')}</h1>
						<FormSection>
							<TextInput
								placeholder="Username"
								name="principal"
								value={this.state.principal}
								onChange={this.onChange}
								icon="fa fa-user"
							/>
							<PasswordInput
								placeholder="Password"
								name="password"
								value={this.state.password}
								onChange={this.onChange}
							/>
						</FormSection>
						<FormSection>
							<FormSubmit text="Sign in" />
						</FormSection>
						{this.props.sign_up_invitation_code_required ? (
							<FormFooterLink
								path="mailto:support@financialfitnessgroup.com?subject=Request Account Invitation"
								text="Not a member? Contact your account administrator"
							/>
						) : (
							<FormFooterLink
								path={this.props.forgot_password_path}
								text="Forgot Password?"
							/>
						)}
					</form>
				)}
				{this.state.loading ? (
					<div
						className="loadingOverlay"
						style={
							this.props.overlay_color ? (
								{ backgroundColor: this.props.overlay_color }
							) : (
								{}
							)
						}
					>
						<div className="spinner" />
					</div>
				) : null}
			</div>
		);
	}

	onChange(e) {
		var { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		const { sign_in_path, context, redirect_to_path } = this.props;
		const { principal, password } = this.state;
		const self = this;

		this.setState({ loading: true });

		$.ajax({
			type: 'POST',
			url: sign_in_path,
			data: {
				principal: principal,
				credential: btoa(password),
				context: context
			},
			dataType: 'json'
		}).done(function(data) {
			if (data.status === 'success') {
				const { permissions } = data.user.decoded_access_token;
				const permissionHelper = new PermissionsHelper(permissions);

				if (permissionHelper.isOnlyProctor()) {
					window.location.href = `/admin/${data.account_id}/users`;
				} else {
					window.location.href = redirect_to_path || data.redirect_to;
				}
			} else {
				self.setState({ loading: false, error: data.error });
			}
		});
	}
}
